import React from "react";
import PropTypes from "prop-types";
import StyledIcon from "./styledIcon";

const Manual = ({ fill, ...props }) => (
  <StyledIcon viewBox="0 0 24 19" {...props}>
    <path
      d="M23.0039 0.233277C22.1437 0.0816913 21.2727 0.00366445 20.3999 5.341e-06C17.422 -0.00249249 14.5062 0.871182 12 2.51689C9.48741 0.89279 6.57204 0.0405588 3.60009 0.0613926C2.72727 0.0650517 1.85627 0.143079 0.996117 0.294664C0.714368 0.344362 0.459219 0.49535 0.27662 0.720438C0.0940212 0.945526 -0.00402895 1.22992 0.000127466 1.52241V16.2554C-0.00244253 16.4358 0.0338785 16.6145 0.106506 16.7789C0.179134 16.9433 0.286284 17.0893 0.420331 17.2066C0.554378 17.3238 0.712029 17.4093 0.882065 17.4571C1.0521 17.5049 1.23034 17.5138 1.40411 17.4831C3.12372 17.1785 4.88552 17.229 6.58574 17.6318C8.28596 18.0345 9.89021 18.7813 11.304 19.8281L11.448 19.9141H11.58C11.7131 19.9708 11.8558 20 12 20C12.1442 20 12.2869 19.9708 12.42 19.9141H12.552L12.696 19.8281C14.0999 18.7579 15.6996 17.9869 17.4001 17.5609C19.1007 17.1349 20.8675 17.0625 22.5959 17.3481C22.7697 17.3788 22.9479 17.3699 23.1179 17.3221C23.288 17.2743 23.4456 17.1887 23.5797 17.0715C23.7137 16.9543 23.8209 16.8083 23.8935 16.6439C23.9661 16.4795 24.0024 16.3007 23.9999 16.1203V1.38736C23.9874 1.10762 23.8818 0.840657 23.7007 0.630745C23.5195 0.420834 23.2736 0.280591 23.0039 0.233277ZM11 18C8.77988 16.805 6.50859 15.9984 4 16C3.604 16 1.908 16 1.5 16L1.40411 1.52241C1.80378 1.49884 3.60034 1.49884 4 1.52241C6.56004 1.51952 8.86428 2.55579 11 4V18ZM22.5959 15.7909C22.1879 15.7909 20.396 15.7909 20 15.7909C17.4914 15.7893 15.2201 16.805 13 18L12.696 4C14.8317 2.55579 17.44 1.51952 20 1.52241C20.3997 1.49884 22.1962 1.49884 22.5959 1.52241V15.7909Z"
      fill={fill}
    />
  </StyledIcon>
);

Manual.propTypes = {
  fill: PropTypes.string
};

Manual.defaultProps = {
  fill: "black"
};

export default Manual;
